import { Action } from '@ngrx/store';

import { ProvisionData } from '../shared/models/provision.model';

export const PROVISION_GET = '[Provision] get';
export const PROVISION_SAVE = '[Provision] save';
export const PROVISION_CLEAR = '[Provision] clear';

export class ProvisionGetAction implements Action {
  public readonly type = PROVISION_GET;
}

export class ProvisionSaveAction implements Action {
  public readonly type = PROVISION_SAVE;
  constructor(public payload: { provisionData: ProvisionData }) {}
}

export class ProvisionClearAction implements Action {
  public readonly type = PROVISION_CLEAR;
}
export type All = ProvisionGetAction | ProvisionSaveAction | ProvisionClearAction;
